import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'tokenCNY',
})
export class TokenCNYPipe implements PipeTransform {
  transform(value: number | string): string {
    const num = Number(value);
    const res = Math.abs(num / 100).toFixed(2);
    return num < 0 ? `-¥${res}` : `¥${res}`;
  }
}
